import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-924e6884")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "filters_panel" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_RefundDialog = _resolveComponent("RefundDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      showDelete: false,
      showSave: false,
      title: 'Rimborsi App'
    }),
    _createVNode(_component_Panel, {
      collapsed: false,
      class: "p-mb-3",
      header: "Filtri avanzati",
      toggleable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.advFilters.from_to,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.advFilters.from_to = $event)),
            manualInput: false,
            showIcon: true,
            selectionMode: "range",
            placeholder: "Data creazione",
            onDateSelect: _ctx.updateFilters
          }, null, 8, ["modelValue", "onDateSelect"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_AppTable, {
      ref: "dataTable",
      filtersSchema: _ctx.filters,
      service: _ctx.service,
      stateKey: _ctx.stateKey,
      onResetFilters: _ctx.onReset,
      onRowClick: _ctx.onRowClick
    }, {
      toolbarLeft: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Export",
          icon: "pi pi-file-excel",
          class: "p-button-outlined",
          loading: _ctx.isExporting,
          onClick: _ctx.handleExport
        }, null, 8, ["loading", "onClick"])
      ]),
      columns: _withCtx(({onApplyFilter}) => [
        _createVNode(_component_Column, {
          field: "created_at",
          header: "Data",
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_DateFormatted, {
              date: data.created_at
            }, null, 8, ["date"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "amount",
          header: "Importo",
          sortable: true,
          showFilterMatchModes: false,
          bodyStyle: "text-align: right",
          headerStyle: "text-align: right"
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_ctx.formatAmount(data.amount)), 1)
          ]),
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Importo...",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "status",
          header: "Stato",
          sortable: true,
          showFilterMatchModes: false
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_Tag, {
              value: _ctx.getStatusLabel(data.status),
              severity: _ctx.getStatusSeverity(data.status)
            }, null, 8, ["value", "severity"])
          ]),
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_Dropdown, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.statusOptions,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Tutti",
              showClear: true,
              onChange: ($event: any) => (onApplyFilter(filterCallback)),
              onClear: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange", "onClear"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "business_name",
          header: "Nome",
          sortable: true,
          showFilterMatchModes: false
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Nome contiene...",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "admin_notes",
          header: "Note",
          sortable: true,
          showFilterMatchModes: false
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Note contengono...",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-check",
              label: "Applica",
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      actions: _withCtx(({data}) => [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-eye",
          class: "p-button-info p-button-sm",
          onClick: ($event: any) => (_ctx.goToDetail(data.id))
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            'Visualizza dettaglio',
            void 0,
            { bottom: true }
          ]
        ]),
        (data.status === 'requested')
          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "pi pi-check-circle",
              class: "p-button-success p-button-sm p-ml-2",
              onClick: _withModifiers(($event: any) => (_ctx.onRefund(data)), ["stop"])
            }, null, 8, ["onClick"])), [
              [
                _directive_tooltip,
                'Rimborsa',
                void 0,
                { bottom: true }
              ]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["filtersSchema", "service", "stateKey", "onResetFilters", "onRowClick"]),
    _createVNode(_component_RefundDialog, {
      visible: _ctx.showRefundDialog,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRefundDialog = $event)),
      refund: _ctx.refundInEdit,
      "onUpdate:refund": _cache[2] || (_cache[2] = ($event: any) => (_ctx.refundInEdit = $event)),
      onSaved: _ctx.onRefundSaved
    }, null, 8, ["visible", "refund", "onSaved"])
  ]))
}